module.exports = __webpack_public_path__ + "img/7.aa3dd245.jpg";